import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles/SettingEditor'
import './styles/mentionsStyles.css'
import RichTextEditor from '../sitewide/RichTextEditor'

const PLAIN_WIDTH = 550 // px
const RICH_WIDTH = 550 // px
const PLACEHOLDER_TEXT = {
  subject: 'Type subject here',
  body:
    'Enter text for message here. Use the @ symbol to add variables like: @patient_first_name.',
}

const EmailBodyEditor = ({
  bodyState,
  handleSearchChange,
  isEmail,
  mentionableData,
  MentionSuggestions,
  plugins,
  updateBodyState,
  isMessageSetting,
}) => (
  <div className="settingsEmailContainer">
    <div className="email-body-editor" style={styles.settingsEmailBody}>
      <RichTextEditor
        isMessageSetting={isMessageSetting}
        editorState={bodyState}
        width={!isEmail ? PLAIN_WIDTH : RICH_WIDTH}
        updateBodyState={updateBodyState}
        placeholder={PLACEHOLDER_TEXT.body}
        plugins={plugins}
      />
      <MentionSuggestions
        onSearchChange={handleSearchChange}
        suggestions={mentionableData}
      />
    </div>
  </div>
)

EmailBodyEditor.propTypes = {
  bodyState: PropTypes.shape({
    getCurrentContent: PropTypes.func.isRequired,
  }),
  handleSearchChange: PropTypes.func.isRequired,
  isEmail: PropTypes.bool,
  mentionableData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ),
  MentionSuggestions: PropTypes.func.isRequired,
  plugins: PropTypes.arrayOf(PropTypes.object),
  updateBodyState: PropTypes.func.isRequired,
}

export default EmailBodyEditor



// WEBPACK FOOTER //
// ./src/components/Settings/EmailBodyEditor.js